import  * as React from 'react'
// Translation
import {useI18next} from 'gatsby-plugin-react-i18next'
import { graphql } from 'gatsby';
//components
import Layout from '../../components/layout/layout'
import { Seo } from '../../components/seo';
import { Link } from 'gatsby-plugin-react-i18next';

const Fasercompounds  = () => {
    const {t} = useI18next();
    return (
        <Layout pageTitle={t('title')} subTitle={t('subtitle')}>
          {/* Block mit weissem hintergrund 
          <div className='row'>

            <div className='col-12'>
              <div className='container'>
                <BoxInfo description={t('text')} />
              </div>
            </div>
          </div>
        */}
          <div className='row'>
            {/* 1 oder mehr Blöcke am Anfang: Titel und Text / ggf später ein Bild */}
            <div className='col-12'>
              <div className='container'>
            {/* 1: Überschrift Die Rohstoffe */}
                <h1 align="center"> {t('title1')} </h1>
                <p> {t('text11')} </p>
                {/* 1: Holzmehl */}
                <h2 align="center"> {t('title2')} </h2>
                 {/* 2. Cellulose */}
                <p> {t('text21')} </p>
                <p> {t('text22')} </p>
                <p> {t('text23')} </p>
                <h2 align="center"> {t('title3')} </h2>
                 {/* 3: Hanf */}
                <p> {t('text31')} </p>
                <p> {t('text32')} </p>
                <p> {t('text33')} </p>
                 {/* 4. einsatz */}
                <h2 align="center"> {t('title4')} </h2>
                <p> {t('text41')} </p>
               
                {/*                 
                <h2 align="center"> {t('title5')} </h2>
                <p> {t('text51')} </p>
                <p> {t('text52')} </p>
               */}

                <h2 align="center"> {t('title6')} </h2>
                <p> {t('text61')} &nbsp; <Link to='/Biokunststoffe/forbio-forligno-bio'> {t('text611')}</Link> </p>
                <p> {t('text62')} &nbsp; <Link to='/WPC/wpc-forligno'> {t('text621')}</Link> </p>
                <p> {t('text63')} </p>

              
                {/*<p>{t('bildtext1')}</p>              : ggf ein Bild einfügen / passt hier aber nicht
                <StaticImage alt="ein bild" src="../images/CAD-Zeichnungen-RK.jpg"/> */}
              </div>
            </div>
          </div>
        </Layout>

    );
};

export default Fasercompounds

// Fuer Search engine optimizationjj
export const Head = () =>( <Seo title="Produktentwicklung" keywords="Produktentwicklung Biopolymere" /> )

// Für Mehrsprachigkeit, graphql muss am anfang import werden!
export const query = graphql`
query ($language: String!) 
{
  locales: allLocale
  (
    filter: { ns: { in: ["fasercompounds"] }, language: { eq: $language } }
  ) {
    edges {
      node {
        ns
        data
        language
      }
    }
  }
}
`;